import { render, staticRenderFns } from "./AddFiles.vue?vue&type=template&id=507b51aa&scoped=true&"
import script from "./AddFiles.vue?vue&type=script&lang=js&"
export * from "./AddFiles.vue?vue&type=script&lang=js&"
import style0 from "./AddFiles.vue?vue&type=style&index=0&id=507b51aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b51aa",
  null
  
)

export default component.exports